import axios from "axios";


// const api = axios.create({
//     baseURL: "http://localhost:5000",
//     withCredentials: true, // Allows sending cookies
// });

 const api = axios.create({
     baseURL: "https://payweek.com/api", // Live backend URLc
     withCredentials: true, // Allows sending cookies
 });


// Set the access token directly in Axios headers
export const setAccessToken = (token) => {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

// Axios response interceptor for handling token refresh
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                 //Call refresh token endpoint
                const { data } = await axios.post("https://payweek.com/api/refresh-token", {}, { withCredentials: true });

                //const { data } = await axios.post("http://localhost:5000/refresh-token", {}, { withCredentials: true });
                setAccessToken(data.accessToken);
                originalRequest.headers["Authorization"] = `Bearer ${data.accessToken}`;
                return api(originalRequest); // Retry the original request
            } catch (err) {
                console.error("Token refresh failed.");
                return Promise.reject(err);
            }
        }

        return Promise.reject(error);
    }
);

export default api;
